class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItemsList =
        this.closest('cart-drawer-items') || this.closest('cart-items');
      const link = this.querySelector('a');
      const lineItemId = this.dataset.lineItemId;
      const packaging_product_id = link.dataset['property-_packaging_product'];
      const product_contents = link.dataset.propertyContents;

      console.warn('link', link.dataset.propertyContents);

      if (!packaging_product_id || isNaN(packaging_product_id)) {
        console.warn(
          'No valid packaging product ID provided, proceeding to remove the item only.',
        );
      }

      try {
        // Fetch the current cart to get the item count
        const cartResponse = await fetch(
          window.Shopify.routes.root + 'cart.js',
        );
        if (!cartResponse.ok) {
          throw new Error('Failed to fetch cart data');
        }
        const cart = await cartResponse.json();

        let packaging_product_count = 0;
        if (packaging_product_id && !isNaN(packaging_product_id)) {
          // Find all products that match both variant_id and contents
          const matching_packaging_products = cart.items.filter(
            (item) =>
              item.variant_id === parseInt(packaging_product_id) &&
              item.properties &&
              item.properties['_contents'] === product_contents,
          );

          packaging_product_count = matching_packaging_products.reduce(
            (total, product) => total + product.quantity,
            0,
          );
          console.warn(
            'Found',
            packaging_product_count,
            'packaging products with ID',
            packaging_product_id,
            'and contents',
            product_contents,
          );
        }

        // Construct the updates object
        const updates =
          packaging_product_id && packaging_product_count > 0
            ? {
                [packaging_product_id]: packaging_product_count - 1,
                [lineItemId]: 0,
              }
            : { [lineItemId]: 0 };

        // Update the cart with the new quantities
        const updateResponse = await fetch(
          window.Shopify.routes.root + 'cart/update.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              updates: updates,
            }),
          },
        );

        if (!updateResponse.ok) {
          throw new Error('Failed to update cart');
        }

        const data = await updateResponse.json();
        console.warn('Cart successfully updated with new quantities:', data);

        const cartCountBadge = document.querySelector('.cart-count-badge');
        if (cartCountBadge) {
          cartCountBadge.textContent = data.item_count || 0;
        }

        // Manually specify the sections to reload
        const sections = ['cart-drawer', 'main-cart'];

        // Fetch the updated sections
        const sectionsResponse = await fetch(
          `/?sections=${sections.join(',')}`,
        );

        if (!sectionsResponse.ok) {
          throw new Error('Failed to fetch updated sections');
        }

        const sectionsData = await sectionsResponse.json();

        // Update the cart drawer section
        const cartDrawerBody = document.querySelector('#CartDrawer-Body');
        if (cartDrawerBody) {
          const cartDrawerHTML = new DOMParser()
            .parseFromString(sectionsData['cart-drawer'], 'text/html')
            .querySelector('#CartDrawer-Body').innerHTML;
          cartDrawerBody.innerHTML = cartDrawerHTML;
        }

        // Update the main cart items section
        const cartBody = document.querySelector('.cart__body');
        if (cartBody) {
          const newCartBody = new DOMParser()
            .parseFromString(sectionsData['main-cart'], 'text/html')
            .querySelector('.cart__body').innerHTML;
          cartBody.innerHTML = newCartBody;
        }

        // Open the minicart
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('is-visible');
          cartDrawer.classList.add('is-open');
          cartDrawer.focusOnCartDrawer();
        } else {
          console.warn('Cart drawer element not found.');
        }
      } catch (error) {
        console.error('Error updating cart via Shopify API:', error);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]'),
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.customDelegate('click', '.js-line-item-selling-plan-switcher', this.onSellingPlanChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.key,
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
    );
  }

  onSellingPlanChange(event, target) {
    this.updateSellingPlan({
      key: target.dataset.key,
      quantity: target.dataset.quantity,
      sellingPlanId: target.dataset.sellingPlanId,
      target
    });
  }

  getSectionsToRender() {
    return [
      ...Cart.getLiveRegions(),
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section: document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
      },
    ];
  }

  updateQuantity(key, line, quantity, name) {
    const body = JSON.stringify({
      id: key,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    Cart.update(body)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.querySelector(section.id);

          if (!elementToReplace) return;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
      })
      .catch((error) => {
        console.error(error);
        const quantityInputs = document.querySelectorAll(
          `[id*="ProductQuantity-${line}"], [id*="ProductQuantity-${line}-mobile"] `,
        );

        if (quantityInputs.length) {
          quantityInputs.forEach((input) => {
            input.value = input.getAttribute('value');
          });
        }

        this.updateLiveRegions(line, this.currentItemCount);
      });
  }

  updateSellingPlan({
     key,
     quantity,
     sellingPlanId = null,
     target
  }) {
    const body = JSON.stringify({
      id: key,
      quantity,
      selling_plan: sellingPlanId,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    target.classList.add('is-loading');

    Cart.update(body)
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.querySelector(section.id);

            if (!elementToReplace) return;

            elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
            );
          });

        })
        .catch((error) => {
          console.error(error);
        });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach((error) => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`).value,
          );
        });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-items', CartItems);
